import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable, from } from 'rxjs';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { EmployeeService } from 'src/app/core/services/employee.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-convert-user-to-employee',
  templateUrl: './convert-user-to-employee.component.html'
})
export class ConvertUserToEmployeeComponent implements OnInit {

  @Input() userId: string;
  @Output() saveCallback = new EventEmitter<any>();
  @Output() cancelCallback = new EventEmitter<any>();

  @ViewChild('makeEmployeeForm') makeEmployeeForm: NgForm;

  userObject: any = null;
  currentCompanyId: string;
  selectedOrganizationalManagerObjectsArray: any[] = [];
  userToEmployeeObject: any = {
    userId: null,
    organizationalManagerId: null,
    title: null
  };

  loadingUserDetailsFlag: boolean = true;
  makingEmployeeFlag: boolean = false;

  constructor(
    private authService: AuthService,
    private employeeService: EmployeeService,
    private userService: UserService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    this.userToEmployeeObject.userId = this.userId;
    this.currentCompanyId = this.authService.getUserDetails().company.companyId;
    this.getUserDetails();
  }

  getUserDetails() {
    this.loadingUserDetailsFlag = true;
    this.userService.getUserDetails(this.userId, (data) => {
      data.userDetails.name = data.userDetails.firstName;
      data.userDetails.name = _.isNull(data.userDetails.lastName)
        ? data.userDetails.name
        : data.userDetails.name + ' ' + data.userDetails.lastName;
      if (!_.isNull(data.userDetails.manager)) {
        data.userDetails.manager.name = data.userDetails.manager.firstName;
        data.userDetails.manager.name = _.isNull(data.userDetails.manager.lastName)
          ? data.userDetails.manager.name
          : data.userDetails.manager.name + ' ' + data.userDetails.manager.lastName;
        this.selectedOrganizationalManagerObjectsArray.push(data.userDetails.manager);
        this.userToEmployeeObject.organizationalManagerId = data.userDetails.manager.userId;
      }
      this.userObject = data;
      this.loadingUserDetailsFlag = false;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      this.loadingUserDetailsFlag = false;
    });
  }

  convertToEmployee() {
    if (this.makeEmployeeForm.valid) {
      this.makingEmployeeFlag = true;
      this.employeeService.setUserToEmployee(this.userToEmployeeObject, (data) => {
        this.alertsAndNotificationsService.showBannerMessage(
          'Application User ' + this.userObject.userDetails.name + ' has been converted to an Employee.',
          'success'
        );
        this.saveCallback.emit(data);
      }, (error) => {
        this.makingEmployeeFlag = false;
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  cancel() {
    this.cancelCallback.emit();
  }

  public getOrganizationalManagers = (searchTerm: string): Observable<any[]> => {
    const searchObject = {
      searchText: searchTerm,
      page: 1,
      size: 10,
      companyId: this.currentCompanyId
    };
    return from(
      this.employeeService.getOrganizationalManagersPromiseForTypeAhead(searchObject).then((data: any) => {
        data.forEach(val => {
          val.name = val.firstName;
          val.name = _.isNull(val.lastName) ? val.name : val.name + ' ' + val.lastName;
        });
        return data;
      })
    );
  }

  organizationalManagerTypeAheadManagerAdded(tag) {
    this.userToEmployeeObject.organizationalManagerId = tag.id;
  }

  organizationalManagerTypeAheadManagerRemoved(tag) {
    this.userToEmployeeObject.organizationalManagerId = null;
  }

  removeItem(item, index) {
    this.selectedOrganizationalManagerObjectsArray.splice(index, 1);
  }
}
